import { STATES } from '../../../../../lib/routes'
import { $state } from '../../../ng-compat/imports'

/**
 * Controller Class for OfflineModal
 */
export class OfflineModalController {
  public dismissible: $TSFixMe
  constructor(public close: $TSFixMe) {
    'ngInject'
    this.dismissible = false
  }

  public transitionToSaleScreen() {
    this.close()
    $state.go(STATES.SALE)
  }
}
